export interface ConversationMessage {
  author: string;
  message: string;
  timestamp: Date;
  origin: MessageOrigin;
  attachments: Array<string | { fileName: string; uploadId?: string }>;
}

export enum MessageOrigin {
  vendor = 'vendor',
  user = 'user',
  admin = 'admin',
}

export interface SendMessageJobInfo {
  id: string;
  translatedDate: Date;
  user: string;
  jobName: string;
  jobNumber: string;
  email: string;
  vendorName: string;
  status: string;
  jobUid: string;
  messagesId?: string;
}

export interface SendMessageRequest {
  jobInfo: SendMessageJobInfo;
  message: string;
  attachments: { fileName: string; uploadId: string }[];
}

export interface JobDetails {
  files: import('./vendor-order.model').Files[];
  jobStatus: string;
  quote?: { acceptedBy?: string; acceptedDate?: Date; normal?: { costs: unknown[]; totalCost: number; currency: string } };
  changeJustificationDtp?: string;
}
